export default __webpack_public_path__ + "static/media/legal-team-prosecutor2.8a63fb36.png";